module.exports = __webpack_public_path__ + "img/root100.af8ea8b0.png";